var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcLogoJcb = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 42,
    fill: "none",
    viewBox: "0 0 64 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E3",
    d: "M64 38.4c0 1.988-1.694 3.6-3.783 3.6H3.783C1.693 42 0 40.388 0 38.4V3.6C0 1.612 1.694 0 3.783 0h56.434C62.307 0 64 1.612 64 3.6v34.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F549D",
    d: "M24.525 6.99H17.82c-3.259 0-5.448 2.19-5.448 5.447v9.745c0 .005 0 .01.002.014.257 1.222 1.537 2.143 2.978 2.143 1.591 0 2.79-1.118 2.79-2.6v-4.866h4.1v4.802c0 2.739-3.525 4.032-5.907 4.043-1.41-.006-2.79-.439-3.788-1.188-.021-.015-.05-.018-.073-.006-.02-.01-.044-.01-.064 0-.023.012-.038.036-.038.062v10.756c0 .038.031.07.07.07h6.897c2.431 0 5.257-2.297 5.257-5.258V7.06c0-.039-.03-.07-.07-.07z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B41F36",
    d: "M38.002 6.99h-6.644c-3.31 0-5.448 2.114-5.448 5.385v5.504c0 .027.016.052.04.063.025.012.054.008.075-.01.58-.483 1.514-1.059 2.676-1.059h7.143v1.3c-1.735-.38-3.339-.553-4.107-.553-1.817 0-3.296 1.479-3.296 3.296v.064c0 1.817 1.479 3.296 3.296 3.296.932 0 2.553-.151 4.107-.49v1.173h-7.143c-1.028 0-2.002-.384-2.672-1.055-.02-.02-.05-.026-.076-.015-.026.01-.043.036-.043.064v11.389c0 .038.031.07.07.07h6.833c2.431 0 5.258-2.297 5.258-5.258V7.06c0-.039-.031-.07-.07-.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#329947",
    d: "M41.666 24.143c0 .038.031.07.07.07h2.973c.799 0 1.525-.727 1.525-1.525 0-.798-.727-1.525-1.525-1.525h-2.973c-.039 0-.07.031-.07.07v2.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#329947",
    d: "M51.67 6.99h-6.581c-1.752 0-3.175.592-4.127 1.635 0 0-1.384 1.35-1.384 3.576v4.602c0 .038.031.07.07.07h7.972c1.094 0 2.019.924 2.019 2.018 0 1.095-.925 2.019-2.019 2.019-.038 0-.07.031-.07.07 0 .038.032.07.07.07 1.238 0 2.209.858 2.209 1.954 0 1.115-.95 1.956-2.209 1.956h-7.972c-.039 0-.07.03-.07.07v10.312c0 .039.031.07.07.07h6.833c2.432 0 5.258-2.297 5.258-5.258V7.06c0-.039-.031-.07-.07-.07z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#329947",
    d: "M41.736 20.606h2.973c.793 0 1.462-.67 1.462-1.462 0-.798-.727-1.525-1.524-1.525h-2.911c-.039 0-.07.032-.07.07v2.848c0 .038.031.07.07.07z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLogoJcb, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_logo_JCB.5faee8a6.svg";
export { ForwardRef as ReactComponent };